import { Spinner } from '../../Components/Spinner/Spinner'

export const Loading: React.FC = () => {
  return (
    <div className="grid place-items-center">
      <Spinner />
    </div>
  )
}
